/**
 * @generated SignedSource<<d8480dca3582dbdbea9e9acb1ccc1081>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ReadMentionPayload",
    "kind": "LinkedField",
    "name": "readMention",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Error",
        "kind": "LinkedField",
        "name": "error",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MentionListQuery_readMentionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MentionListQuery_readMentionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a26758671ab04f88b013a898b51fa9db",
    "id": null,
    "metadata": {},
    "name": "MentionListQuery_readMentionMutation",
    "operationKind": "mutation",
    "text": "mutation MentionListQuery_readMentionMutation(\n  $input: ReadMentionInput!\n) {\n  readMention(input: $input) {\n    ok\n    error {\n      message\n    }\n  }\n}\n"
  }
};
})();

node.hash = "e4e969741aa55514313960fde290cb02";

module.exports = node;
